//============================================================================
// Name        : index.ts
// Purpose     : Implement Rails per page typescript coding
// Created     : 2020-01-02
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================
import * as AdminClientActivityReport from './admin/client_activity_report';
import * as Eaa from "./alerts/eaa";
import * as ReplenishmentAlerts from "./alerts/replenishments";
import * as ReplenishmentPickView from "./alerts/replenishment_pick_view";
import * as UniversalPermanentStatusRegistry from "./tenant_admin/universal_permanent_status_registry";
import * as AdjustmentRequests from "./tenant_admin/adjustment_requests";
import * as AdjustmentRequestsStoreModal from "./adjustment_requests/store_modal";
import * as ApiMonitor from "./api_monitor/api_monitor";
import * as AssetDetails from "./items/asset_details";
import * as BulkPrint from "./printing/bulk_print";
import * as CatalogExportProgressUpdate from "./items/catalog_export_progress_update";
import * as ItemsMappings from "./items/mappings";
import * as CatalogSidebar from "./items/catalog_sidebar";
import * as CdmIndex from "./cdm/index";
import * as DeleteDialog from "./common/delete_dialog";
import * as SyncIntegrationDialog from "./common/sync_integration_dialog";
import * as ConfirmDialog from "./common/confirm_dialog";
import * as Popconfirm from "./common/popconfirm";
import * as RestPinDialog from "./common/reset_pin_dialog";
import * as Disposal from "./manufacturing/disposal";
import * as ElcAlarm from "./elc/alarm";
import * as ElcEmployees from "./elc/employees";
import * as ElcPlanningCalendar from "./elc/planning_calendar";
import * as ElcProductionCalendar from "./elc/productions/productions_calendar";
import * as ElcProductionCards from "./elc/productions/cards";
import * as ElcProductionCharts from "./elc/productions/charts";
import * as ElcProductionEmployeeLogTime from "./elc/productions/employee_log_time";
import * as ElcProductionHelpRequest from "./elc/productions/help_requests";
import * as ElCProductionLiveUpdateCard from "./elc/productions/live_update_card";
import * as ElcProductionNew from "./elc/productions/new";
import * as ElcStandard from "./elc/standard";
import * as ElcTempAgencyAssign from "./elc/temp_agency_assign";
import * as ElcTempAgencyCheckin from "./elc/temp_agency_checkin";
import * as ElcReportsProductionIndex from "./elc/reports/productions/index";
import * as ErcPurchaseOrderReceivings from "./erc/purchase_order_receivings";
import * as ExcludedCategories from "./lightspeed/excluded_categories";
import * as ExclusionSidebar from "./lightspeed/exclusion_side_bar";
import * as ExitAlertsView from "./exit_alerts/view";
import * as ExternalMessageAlert from "./external/expermient_messages";
import * as HandheldApiLogs from "./handheld/api_logs/api_logs";
import * as HeartlandProgressUpdate from "./heartland/heartland_progress_update";
import * as OdooProgressUpdate from "./odoo/odoo_progress_update";
import * as RetailExpressProgressUpdate from "./retail_express/retail_express_progress_update";
import * as NetsuiteProgressUpdate from "./netsuite/netsuite_progress_update";
import * as NetsuiteStoreInventoryStatisticsProgressUpdate from "./netsuite/store_inventory_statistics_progress_update";
import * as Integrations from "./integrations/integrations";
import * as SampleCatalogProgressUpdate from "./integrations/sample_catalog_progress_update";
import * as IntegrationSubview from "./integrations/integration_subview";
import * as SuperAdminAuth from "./integrations/super_admin_auth";
import * as Inventory from "./epc_tags/inventory";
import * as InventoryPushToHandheld from "./epc_tags/push_to_handheld";
import * as BulkRePrint from "./epc_tags/bulk_re_print";
import * as ItemGroup from "./items/item_group";
import * as CatalogItems from "./items/catalog_items";
import * as LightspeedModalCategories from "./lightspeed/modal_categories";
import * as LightspeedSidebar from "./lightspeed/sidebar";
import * as LiveSalesOrders from "./so_processes/live_so_processes";
import * as LiveSalesOrdersToZone from "./so_processes/live_so_to_zone_processes";
import * as LoadingDocks from "./pallet_build/loading_docks";
import * as LsCompare from "./lightspeed/ls_compare";
import * as LsCompareDetails from "./lightspeed/compare_v2_details";
import * as LsLastCalculated from "./lightspeed/last_calculated";
import * as LsProgressUpdate from "./lightspeed/ls_progress_update";
import * as LsUndoProgressUpdate from "./lightspeed/ls_undo_progress_update";
import * as ManufacturingProductionCalendar from "./manufacturing/production/calendar";
import * as ManufacturingProductionReconciliation from "./manufacturing/production/reconciliation";
import * as MfQuickShipOut from "./manufacturing/sales_orders/quick_ship_out";
import * as MfVerifyShipping from "./manufacturing/sales_orders/verify_shipping";
import * as MfSoAllocations from "./manufacturing/sales_orders/allocations";
import * as MfWebPushLogs from "./manufacturing/web_push_logs";
import * as MfWebPushV2Logs from "./manufacturing/web_push_v2_logs";
import * as NavErrorTemplate from "./nav/error_template";
import * as Partners from "./partners/partners";
import * as QualityHold from "./manufacturing/quality_hold";
import * as Returns from "./manufacturing/sales_orders/returns";
import * as Rfid from "./rfid/rfid";
import * as RfidPrint from "./rfid/print";
import * as RfidPrintLsPoItems from "./rfid/print_ls_po_items";
import * as RfidPrintR2 from "./rfid/print_r2";
import * as RfidTagging from "./manufacturing/rfid_tagging";
import * as SaveWOState from "./manufacturing/production/save_wo_state";
import * as Shipments from "./transactions/shipments";
import * as ShipmentsTransferDetails from "./transactions/shipments_transfer_details";
import * as TransferIn from "./transactions/transfer_in";
import * as TransferOut from "./transactions/transfer_out";
import * as Shippings from "./pallet_build/cartons";
import * as ShopifyProgressUpdate from "./shopify/shopify_progress_update";
import * as CustomD365ProgressUpdate from "./custom_d365/custom_d365_progress_update";
import * as QuickbookProgressUpdate from "./quickbook/quickbook_progress_update";
import * as Sidebar from "./epc_tags/sidebar";
import * as SummarizationStats from "./logs/summarization_stats";
import * as TenantHandheldSettings from "./handheld/tenant_handheld_settings";
import * as TheftAlertInstant from "./theft_alerts/instant";
import * as TzProgressUpdate from "./treez/tz_progress_update";
import * as VendProgressUpdate from "./vend/vend_progress_update";
import * as AcumaticaProgressUpdate from "./acumatica/acumatica_progress_update";
import * as Customers from "./customers/customers";
import * as Locations from "./customers/locations";
import * as ELCLiveEmployeeCount from "./elc/productions/live_employee_count";
import * as MfBinManagement from "./manufacturing/bin_management";
import * as ELCProductionsLiveAlarm from "./elc/productions/live_alarm";
import * as ManufacturingSoCount from "./manufacturing/sales_orders/so_count";
import * as ShippingShipments from "./shipping/shipments/shipments";
import * as ShippingPickings from "./shipping/pickings/pickings";
import * as ShippingPickingHistory from "./shipping/pickings/history";
import * as ShippingPickingShow from "./shipping/pickings/show";
import * as ShippingInboundLiveMonitoring from "./shipping/inbound/live_monitoring";
import * as History from "./manufacturing/so_processes/history";
import * as PrintAction from "./manufacturing/so_processes/print_action";
import * as SoZoneHistory from "./manufacturing/so_zone_processes/history";
import * as SoZonePrintAction from "./manufacturing/so_zone_processes/print_action";
import * as CustomModulesBin from "./custom_modules/bin";
import * as IRMSInventoryRequests from "./irms/inventory_requests";
import * as IRMSRequestEpcs from "./irms/request_epcs";
import * as EOSWebhookLogs from "./eos/webhook_logs";
import * as AssetMovements from "./reports_and_logs/asset_movements";
import * as ToasterNotifications from "./common/toaster_notifications";
import * as AccessLog from "./users/access_log";
import * as InventoryValuation from "./custom_reports/inventory_valuation";
import * as MfApiLogs from "./manufacturing/api_logs";
import * as cdmHhIndex from "./cdm_handhelds";
import * as ManageCdmHandhelds from "./manage_cdm_handhelds";
import * as ManufacturingTagsGenerate from "./manufacturing/tags/generate";
import * as EOSTransferReceivingSearch from "./eos/transfer/receiving/search";
import * as ERCTransfer from "./erc/transfer";
import * as ERCReceiving from "./erc/receiving";
import * as ErcMasterTagDashboard from "./erc/master_tag/dashboard";
import * as OnHandInventory from "./manufacturing/on_hand_inventory";
import * as COCITransaction from "./coci/transaction";
import * as AssetsComponents from "./epc_tags/assets_components";
import * as Helper from './common/helper';
import * as CRMInfo from "./crm/info";
import * as CRMPrintAction from "./crm/print_action";
import * as CRMPinAuthentication from "./crm/pin_authentication";
import * as SgtinSettings from "./general_settings/sgtin_settings";
import * as GeneralSettingsPage from "./general_settings/general_settings_page";
import * as TransferslipReceiving from "./transferslip/receiving";
import * as EpcSettingProfilesImport from "./epc_setting_profiles/import"
import * as EpcSettingProfilesForm from "./epc_setting_profiles/form"
import * as EpcSettingProfilesLocationRestriction from "./epc_setting_profiles/location_restriction"
import * as MfSoZoneCount from "./manufacturing/sales_orders_to_zone/so_count";
import * as MfSoZoneAllocations from "./manufacturing/sales_orders_to_zone/allocations";
import * as MfSoZoneVerifyShipping from "./manufacturing/sales_orders_to_zone/verify_shipping";
import * as NTOTransferOrders from "./nto/transfer_orders";
import * as GeigersBulkActions from "./geigers/bulk_actions";
import * as WOPModes from "./wop/modes";
import * as WOPPickingIndex from "./wop/picking";
import * as WOPPickingShow from "./wop/picking/show";
import * as WOPShippingIndex from "./wop/shipping";
import * as ReplenishmentTemplatesIndex from "./replenishment_templates/index";
import * as ReplenishmentTemplatesShow from "./replenishment_templates/show";
import * as ZoneUnauthorizedChangeStatusForm from "./location_setting_zone_unauthorizeds/change_status_form";
import * as SalesOrdersShow from "./sales_orders/show";
import * as FloorKeonnCalibration from "./floors/keonn_calibration";
import * as ItemDetailsMapV2 from "./items/map_v2";
import * as SubZoneMapArea from "./sub_zones/map_area";
import * as SubZoneBinFlag from "./sub_zones/bin_flag";
import * as CustomerSearchSelect from "./customer_search_select";


/// Execute module only on the specified page
export function InitPage(pageClass: string, initFunc: () => void): void {
  //-- jQuery Helpers

  // Case insensitive Contains
  $.expr.pseudos.contains = $.expr.createPseudo((arg) => {
    return (elem) => {
      return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
  });

  const classes = pageClass.split(" ");
  let pageFound = false;
  const bodyEl = document.querySelector("body");

  // The first class is the controller, so we always want to make sure
  // we're loading any given page on the controller context
  if (bodyEl.classList.contains(classes[0])) {
    for (const c of classes) {
      if (bodyEl.classList.contains(c)) {
        pageFound = true;
      }
    }
  }

  if (!pageFound) {
    return;
  }

  // Execute our page initialization code
  initFunc();
}

/// Execute module only when ALL specified classes are present (strict check)
export function InitPageStrict(pageClass: string, initFunc: () => void): void {
  const classes = pageClass.split(" ");
  const bodyEl = document.querySelector("body");

  // Check that ALL classes are present in the body
  const allClassesPresent = classes.every(className => bodyEl.classList.contains(className));

  if (!allClassesPresent) {
    return;
  }

  // Execute our page initialization code
  initFunc();
}

export function InitApp() {
  ToasterNotifications.LoadPage();

  DeleteDialog.LoadPage();
  SyncIntegrationDialog.LoadPage();
  ConfirmDialog.LoadPage();
  Popconfirm.LoadPage();
  RestPinDialog.LoadPage();

  // Admin
  AdminClientActivityReport.LoadPage();

  // Load all registered pages
  Sidebar.LoadPage();
  LightspeedSidebar.LoadPage();
  ExclusionSidebar.LoadPage();
  ExcludedCategories.LoadPage();
  LightspeedModalCategories.LoadPage();
  LsProgressUpdate.LoadPage();
  TzProgressUpdate.LoadPage();
  VendProgressUpdate.LoadPage();
  AcumaticaProgressUpdate.LoadPage();
  ShopifyProgressUpdate.LoadPage();
  CustomD365ProgressUpdate.LoadPage();
  QuickbookProgressUpdate.LoadPage();
  HeartlandProgressUpdate.LoadPage();
  OdooProgressUpdate.LoadPage();
  RetailExpressProgressUpdate.LoadPage();
  NetsuiteProgressUpdate.LoadPage();
  NetsuiteStoreInventoryStatisticsProgressUpdate.LoadPage();
  LsUndoProgressUpdate.LoadPage();
  CatalogExportProgressUpdate.LoadPage();
  CatalogSidebar.LoadPage();
  ItemsMappings.LoadPage();
  ItemGroup.LoadPage();
  CatalogItems.LoadPage();
  HandheldApiLogs.LoadPage();
  TenantHandheldSettings.LoadPage();
  ApiMonitor.LoadPage();
  Integrations.LoadPage();
  SampleCatalogProgressUpdate.LoadPage();
  IntegrationSubview.LoadPage();
  SuperAdminAuth.LoadPage();
  Inventory.LoadPage();
  InventoryPushToHandheld.LoadPage();
  BulkRePrint.LoadPage();
  AssetDetails.LoadPage();
  LsCompare.LoadPage();
  LsCompareDetails.LoadPage();
  LsLastCalculated.LoadPage();
  MfSoAllocations.LoadPage();
  MfQuickShipOut.LoadPage();
  MfVerifyShipping.LoadPage();
  TheftAlertInstant.LoadPage();
  ExternalMessageAlert.LoadPage();
  LiveSalesOrders.LoadPage();
  LiveSalesOrdersToZone.LoadPage();
  ExitAlertsView.LoadPage();
  BulkPrint.LoadPage();
  QualityHold.LoadPage();
  Disposal.LoadPage();
  RfidTagging.LoadPage();
  Partners.LoadPage();
  Shipments.LoadPage();
  ShipmentsTransferDetails.LoadPage();
  TransferIn.LoadPage();
  TransferOut.LoadPage();
  Shippings.LoadPage();
  LoadingDocks.LoadPage();
  Customers.LoadPage();
  Locations.LoadPage();
  ShippingShipments.LoadPage();
  ShippingPickings.LoadPage();
  ShippingPickingHistory.LoadPage();
  ShippingPickingShow.LoadPage();
  ShippingInboundLiveMonitoring.LoadPage();
  CustomModulesBin.LoadPage();
  AssetMovements.LoadPage();
  InventoryValuation.LoadPage();
  MfApiLogs.LoadPage();
  cdmHhIndex.LoadPage();
  ManageCdmHandhelds.LoadPage();
  // Alerts
  Eaa.LoadPage();
  ReplenishmentAlerts.LoadPage();
  ReplenishmentPickView.LoadPage();
  UniversalPermanentStatusRegistry.LoadPage();
  AdjustmentRequests.LoadPage();
  AdjustmentRequestsStoreModal.LoadPage();

  // Epc Setting Profiles
  EpcSettingProfilesImport.LoadPage();
  EpcSettingProfilesForm.LoadPage();
  EpcSettingProfilesLocationRestriction.LoadPage();

  // RRD - CDM
  CdmIndex.LoadPage();

  // RFID Pages
  Rfid.LoadPage();
  RfidPrint.LoadPage();
  RfidPrintR2.LoadPage();
  RfidPrintLsPoItems.LoadPage();

  // Reports and Logs
  SummarizationStats.LoadPage();
  Returns.LoadPage();
  MfWebPushLogs.LoadPage();
  MfWebPushV2Logs.LoadPage();
  MfBinManagement.LoadPage();

  // WO Production
  SaveWOState.LoadPage();
  ManufacturingProductionReconciliation.LoadPage();
  ManufacturingProductionCalendar.LoadPage();
  ManufacturingSoCount.LoadPage();

  // Sales Order To Zone
  MfSoZoneCount.LoadPage();
  MfSoZoneAllocations.LoadPage();
  MfSoZoneVerifyShipping.LoadPage();

  // ELC Common
  ElcStandard.LoadPage();
  ElcEmployees.LoadPage();
  ElcAlarm.LoadPage();
  ElcPlanningCalendar.LoadPage();
  ElcProductionCards.LoadPage();
  ElcProductionCharts.LoadPage();
  ElcTempAgencyAssign.LoadPage();
  ElcTempAgencyCheckin.LoadPage();
  ELCLiveEmployeeCount.LoadPage();

  ElcProductionNew.LoadPage();
  ElcProductionHelpRequest.LoadPage();
  ElcProductionEmployeeLogTime.LoadPage();
  ElcProductionCalendar.LoadPage();
  ElCProductionLiveUpdateCard.LoadPage();
  ELCProductionsLiveAlarm.LoadPage();

  ElcReportsProductionIndex.LoadPage();

  // ERC
  ErcPurchaseOrderReceivings.LoadPage();

  // IRMS
  IRMSInventoryRequests.LoadPage();
  IRMSRequestEpcs.LoadPage();

  // EOS
  EOSWebhookLogs.LoadPage();
  EOSTransferReceivingSearch.LoadPage();

  // Manufacturing
  ManufacturingTagsGenerate.LoadPage();

  NavErrorTemplate.LoadPage();
  History.LoadPage();
  PrintAction.LoadPage();
  SoZoneHistory.LoadPage();
  SoZonePrintAction.LoadPage();
  AccessLog.LoadPage();

  // ERC
  ERCTransfer.LoadPage();
  ERCReceiving.LoadPage();
  ErcMasterTagDashboard.LoadPage();

  OnHandInventory.LoadPage();

  // COCI
  COCITransaction.LoadPage();

  // AssetsComponents
  AssetsComponents.LoadPage();

  // CRM
  CRMInfo.LoadPage();
  CRMPrintAction.LoadPage();
  CRMPinAuthentication.LoadPage();

  // Application helpers
  Helper.LoadPage();

  // General Settings
  SgtinSettings.LoadPage();
  GeneralSettingsPage.LoadPage();
  // Transferslip
  TransferslipReceiving.LoadPage();

  // NTO
  NTOTransferOrders.LoadPage();

  // Geigers
  GeigersBulkActions.LoadPage();

  // WOP
  WOPPickingIndex.LoadPage();
  CustomerSearchSelect.LoadPage();
  WOPPickingShow.LoadPage();
  WOPShippingIndex.LoadPage();
  WOPModes.LoadPage();

  // Sales Orders
  SalesOrdersShow.LoadPage();
  FloorKeonnCalibration.LoadPage();
  ItemDetailsMapV2.LoadPage();
  SubZoneMapArea.LoadPage();
  SubZoneBinFlag.LoadPage();

  // Replenishment Templates
  ReplenishmentTemplatesIndex.LoadPage();
  ReplenishmentTemplatesShow.LoadPage();

  // Unauthorized Zone Alerts
  ZoneUnauthorizedChangeStatusForm.LoadPage();
}
